import React from 'react';
import '../css/Jumbotron.css';
import { SmoothScrollLink } from "organism-react-scroll-nav";


function Jumbotron() {
  return (
    <div className="jumbotron jumbotron-fluid">
        <div className="caption">
            <h1>Find Everything <br></br> You Need</h1>
            <p>Crafted by highly specialized workers,The best furniture you can find on the planet.</p>
            <SmoothScrollLink targetId="Products"> <span>Get Started</span> </SmoothScrollLink>
        </div>
    </div>
  );
}

export default Jumbotron;
